export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative bg-gradient-to-b from-[#F5F7FA] to-white py-20 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        {/* Text Content */}
        <div className="text-center mb-16">
          <h1 className="text-3xl sm:text-4xl md:text-6xl font-black text-[#1A3A5C] mb-6 leading-tight tracking-wide">
            <span className="block whitespace-nowrap">製造業の現場を、</span>
            <span className="block whitespace-nowrap">AIでもう一段上へ</span>
          </h1>
          <p className="text-sm sm:text-base md:text-xl text-[#4A5568] mb-10 leading-relaxed mx-auto">
            <span className="block whitespace-nowrap">製造業×AI開発を専門とするエンジニアが、</span>
            <span className="block">課題ヒアリングから現場に合ったソリューションの提案・実装・導入まで一貫対応します。</span>
          </p>
          <button
            onClick={scrollToContact}
            className="bg-[#1A3A5C] text-white px-12 py-4 rounded-full text-lg font-bold hover:bg-[#2A4A6C] transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            まずは無料相談
          </button>
        </div>

        {/* Hero Image */}
        <div className="relative -mx-6 md:mx-10">
          <div className="md:rounded-3xl overflow-hidden shadow-2xl">
            <img
              src="/assets/hero.jpeg"
              alt="製造現場でのAI導入相談"
              className="w-full h-[400px] md:h-[700px] object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
          </div>
        </div>
      </div>
    </section>
  );
}